module.exports = __webpack_public_path__ + "static/media/MVNZ_web_4.dae1ca5c.jpg";